function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M16 6.9C16 9.11 14.21 10.9 12 10.9C9.79 10.9 8 9.11 8 6.9C8 4.69 9.79 2.9 12 2.9C14.21 2.9 16 4.69 16 6.9Z",
  id: "i2nA5R1uVD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.35 12.63C15.71 12.63 16 12.92 16 13.29C16 15.24 16 20.45 16 22.41C16 22.77 15.71 23.06 15.35 23.06C13.88 23.06 10.12 23.06 8.65 23.06C8.29 23.06 8 22.77 8 22.41C8 20.45 8 15.24 8 13.29C8 12.92 8.29 12.63 8.65 12.63C10.12 12.63 13.88 12.63 15.35 12.63Z",
  id: "b4TpBY1Qq4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.86 3.45C16.86 1.94 18.2 0.72 19.86 0.72C21.51 0.72 22.85 1.94 22.85 3.45C22.85 4.96 21.51 6.18 19.86 6.18C19.45 6.18 19.07 6.11 18.72 5.98C18.65 6.03 18.28 6.27 17.61 6.71L17.78 5.42C17.17 4.63 16.86 3.97 16.86 3.45Z",
  id: "a1oPnyQwdV"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i2nA5R1uVD",
  opacity: 1,
  fill: "#0c0318",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i2nA5R1uVD",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 1
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b4TpBY1Qq4",
  opacity: 1,
  fill: "#0c0318",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1oPnyQwdV",
  opacity: 1,
  fill: "#0c0318",
  fillOpacity: 1
}))));

const SvgSingleUser = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSingleUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/single-user.e5245499.svg";
export { ForwardRef as ReactComponent };